
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import AnalyticsMixin from "@mixins/AnalyticsMixin";
import UserFormBase from '../UserFormBase.vue';

import { UserProfileBaseOwnInterface } from "@service/components/user-form-base/interfaces/UserFormBaseOwnInterface";
import { UserRepository } from '@api/repositories/UserRepository';
import { ObjectRepository } from '@api/repositories/ObjectRepository';
import { SettingsHelper } from '@service/helpers/settingsHelper';
import { RepositoryFabric } from '@api/repositories/RepositoryFabric';
import { UserProfile } from '@api/models/UserProfile';
import { User } from '@api/models/User';

@Component({})
export default class UserFormBaseOwn extends Mixins(UserFormBase, AnalyticsMixin) implements UserProfileBaseOwnInterface {

    originUserDataString = '';
    usersRepository: UserRepository = this.$repositories.get(RepositoryFabric.USER);
    objectRepository: ObjectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
    isLoaded = false;
    helper: SettingsHelper | null = null;

    termsOfUse: any = {};

    showSpinner = false;

    saveOriginDataString(profile: UserProfile, user: User) {
        this.originUserDataString = this.helper?.getStringFromObject({ profile, user }) ?? '';
    }

    async loadData(isOnBoarding = false) {

        const profileParams = await this.getProfileParamsAndSetFieldsAndTags();

        if (profileParams?.termsOfUseUrl) {
            this.termsOfUse = {
                url: profileParams?.termsOfUseUrl,
                value: false,
                show: isOnBoarding
            };
        }

        await this.setOwnProfile();
        this.user = await this.usersRepository.user(this.userId) as User;
        this.saveOriginDataString(this.profile, this.user);

        this.isLoaded = true;
    }

    async setOwnProfile(lang?: string) {
        this.profile = await this.usersRepository.ownProfile(this.fields, lang) as UserProfile;
    }

    tryClose() {
        //
    }

    async save(close = true) {
        this.validationMessages = {};

        if(!this.validate(this.needValidateTags)) {
            return false
        }

        this.$store.dispatch('showSpinner');
        try {
            this.$store.dispatch("setSessionLanguage", this.user.language);

            this.saveProfile();
            this.saveUser();
            this.saveOriginDataString(this.profile, this.user);

            if (close) {
                this.tryClose();
            }

            this.$analytics.setGtagParams(true, false);
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
        }
        finally {
            this.$store.dispatch('hideSpinner');
        }
    }

    async saveProfile() {
        await this.usersRepository.saveOwnProfile(this.profile, this.fields);
    }

    async saveUser() {
        await this.usersRepository.saveUser(this.userId, {
            language: this.user.language,
            notificationSettings: this.user.notificationSettings
        });
    }

    validate(tagsRequired = true): boolean {

        if(!this.isLoaded) { return true; }

        let valid = true;

        this.validationMessages = {};

        valid = this.validateBase(tagsRequired);

        const termsOfUse = this.termsOfUse;
        if(termsOfUse?.show && !termsOfUse?.value) {
            Vue.set(this.validationMessages, "termsOfUse", this.$t("settings.acceptToContinue"));
            valid = false;
        }

        this.valid = valid;

        return valid;
    }

    @Watch('user.language')
    async languageChangeHandler(value: string) {
        try {
            this.showSpinner = true;
            await this.setOwnProfile(value);
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.showSpinner = false;
        }
    }
}
